function _typeof(obj) {
    '@babel/helpers - typeof';
    if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
        _typeof = function _typeof(obj) {
            return typeof obj;
        };
    } else {
        _typeof = function _typeof(obj) {
            return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj;
        };
    }
    return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === 'object' || typeof call === 'function')) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
    }
    return self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== 'function' && superClass !== null) {
        throw new TypeError('Super expression must either be null or a function');
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass)
        _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
import EventTarget from '../event-target';
import TextTrack from '../tracks/text-track';
var NONE = 0;
var LOADING = 1;
var LOADED = 2;
var ERROR = 3;
var HTMLTrackElement = function (_EventTarget) {
    _inherits(HTMLTrackElement, _EventTarget);
    function HTMLTrackElement() {
        var _this;
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        _classCallCheck(this, HTMLTrackElement);
        _this = _possibleConstructorReturn(this, _getPrototypeOf(HTMLTrackElement).call(this));
        var readyState;
        var track = new TextTrack(options);
        _this.kind = track.kind;
        _this.src = track.src;
        _this.srclang = track.language;
        _this.label = track.label;
        _this['default'] = track['default'];
        Object.defineProperties(_assertThisInitialized(_this), {
            readyState: {
                get: function get() {
                    return readyState;
                }
            },
            track: {
                get: function get() {
                    return track;
                }
            }
        });
        readyState = NONE;
        track.addEventListener('loadeddata', function () {
            readyState = LOADED;
            _this.trigger({
                type: 'load',
                target: _assertThisInitialized(_this)
            });
        });
        return _this;
    }
    return HTMLTrackElement;
}(EventTarget);
HTMLTrackElement.prototype.allowedEvents_ = { load: 'load' };
HTMLTrackElement.NONE = NONE;
HTMLTrackElement.LOADING = LOADING;
HTMLTrackElement.LOADED = LOADED;
HTMLTrackElement.ERROR = ERROR;
export default HTMLTrackElement;